const CHAT_GROUPS = {
  'https://shellb2b.devkanggo.com': 'chat_group_dev',
  'https://shellb2bnew.stagging.kanggo.id': 'chat_group_staging',
  'https://shellb2bnew.prodkanggo.com': 'chat_group'
}

function getFirebaseChatGroup () {
  if (process.env.VUE_APP_FIREBASE_CHAT_GROUP) {
    return process.env.VUE_APP_FIREBASE_CHAT_GROUP
  }

  const origin = window.location.origin
  const host = window.location.hostname

  if (CHAT_GROUPS[origin]) {
    return CHAT_GROUPS[origin]
  }

  if (host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0') {
    return 'chat_group_dev'
  }

  return 'chat_group'
}

export { getFirebaseChatGroup }
